import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSpinnerIconComponent } from './mat-spinner-icon.component';



@NgModule({
  declarations: [
	  MatSpinnerIconComponent
  ],
  imports: [
    CommonModule,
	MatProgressSpinnerModule
  ],
  exports: [
	MatSpinnerIconComponent
]
})
export class MatSpinnerIconModule { }
